/**
 * Member (My Labs Plus) price for a regular cents amount, given the org's
 * configured discount percent. Null/0/undefined pct → the regular price
 * unchanged. Pct is clamped to 0–100. Result is rounded to whole cents.
 *
 * Single source of truth for both the API (server-side, authoritative
 * checkout pricing) and the dashboard (client-side preview) so the two
 * never drift on rounding.
 */
export function applyMemberDiscount(regularCents, pct) {
    if (pct == null || pct <= 0)
        return regularCents;
    const clamped = Math.min(100, pct);
    return Math.round(regularCents * (1 - clamped / 100));
}
